module.exports = "/static/assets/9073974a46352f66214bf99db01aab28.svg";